export default __webpack_public_path__ + "static/1624-31f8a14927f5a132a06ac18992febb97.gif";